import { render, staticRenderFns } from "./BillingCity.vue?vue&type=template&id=2d63d192&scoped=true&"
import script from "./BillingCity.vue?vue&type=script&lang=js&"
export * from "./BillingCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d63d192",
  null
  
)

export default component.exports